/**
 *
 * @param {Array<{checked: boolean}>} values
 * @param {number} start
 * @param {number} end
 * @param {Array<{name: string, value: string}>} options
 */
export function questionHaveOneMinimumChecked(values, start, end, options) {
  let check = [];

  let index = 0;
  for (let i = start; i <= end; i++) {
    if (values[i].checked) if (options[index]?.value) check.push(options[index].value);
    index++;
  }

  return check;
}

/**
 *
 * @param {Array<{checked: boolean}>} values
 * @param {number} start
 * @param {number} end
 * @param {Array<string>} answers
 * @param {boolean} prefixNumber
 */
export function questionOneChoice(values, start, end, answers, prefixNumber = true) {
  let answer = '';

  let index = 0;
  for (let i = start; i <= end; i++) {
    if (values[i]?.checked)
      answer = prefixNumber ? `${answers.indexOf(answers[index]) + 1}- ${answers[index]}` : answers[index];
    index++;
  }

  return answer;
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}


/**
 * Stringify and caste value on lower case
 * @func serialize
 * @param {string} str
 * @description Stringify and caste value
 * @returns {string}
 */
function serialize(str) {
  return str.toString().replace(/\s/g, '').toLowerCase()
}

/**
 * @func ObjectValues
 * @param {object} value
 * @returns {string}
 */
function objectValues(value) {
  return Object.values(value).reduce((string, val) => {
    const test = val !== null && val !== undefined
    return (
      string +
      (typeof val === 'object' && val !== null
        ? serialize(objectValues(val))
        : test
          ? serialize(val)
          : '')
    )
  }, '')
}


/**
 * FILTERED VALUE IN ARRAY ITEM
 * @param {string} val
 * @param {Array} data
 * @returns {Array}
 * @author Jordan Kagmeni (Torador)
 */
export function ToradorFilterDom(val, data) {
  return data.filter((el) => {
    return val.length ? objectValues(el).includes(serialize(val)) : true
  })
}

/**
 * SET WORD IN PLURAL
 * @param {string} word 
 * @param {number} number 
 * @returns {string}
 */
export function getPluralWord(word, number) {
  if (number > 1) return word + 's'
  return word
}

/**
 * FORMAT TO VALID SELECTOR CSS
 * @param {string} name 
 * @returns {string}
 */
export function getConformSelector(name) {
  return name.replaceAll(',', '').replaceAll("'", '').replaceAll(' ', '')
}

/**
 * CHECK TARGET ELEMENT
 * @param {string} selector
 * @returns {void} 
 */
export function checkElement(selector) {
  const ques4 = document.querySelector(selector)
  if (ques4) ques4.checked = true
}